"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RunnerSettingsSchema = void 0;
const zod_1 = require("zod");
exports.RunnerSettingsSchema = zod_1.z.object({
    // resolved by device policy manager into RunnerVersion
    runnerUid: zod_1.z.string(),
    runnerVersion: zod_1.z.string(),
    // contributes to assignment
    configuration: zod_1.z.record(zod_1.z.string(), zod_1.z.any()),
});
